import { render } from "./PageTitleCustomer.vue?vue&type=template&id=2bcef5fe"
import script from "./PageTitleCustomer.vue?vue&type=script&lang=js"
export * from "./PageTitleCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__